<template>
  <div>
    <c-tab
      ref="patrolTab"
      type="horizon"
      :inlineLabel="true"
      :dense="true"
      :tabItems="tabItems"
      v-model="tab"
      @tabClick="tabClick"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :popupParam="popupParam"
          :count="count"
          :attachInfo.sync="attachInfo"
          @closePopup="closePopup"
          @changeStatus="changeStatus"
          @transInfo="transInfo"
        />
      </template>
    </c-tab>
  </div>
      <!-- class="full-height" -->
</template>

<script>
import { uid } from 'quasar'
export default {
  name: 'cto-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        saiPatrolId: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      height: '',
      editable: true,
      splitter: 5,
      tab: 'patrolDetail',
      count: 0,
      patrol: {
        saiPatrolId: '',
      },
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'PATROL_RESULT',
        taskKey: '',
      },
      addTabItems: [],
      tabItems: [],
    };
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 36);
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.tabItems = [
        { name: 'patrolDetail', icon: 'edit', label: '순회점검 정보', component: () => import(`${'./patrolDetail.vue'}`) },
      ];
      this.addTabItems = [
        { name: 'patrolImprove', icon: 'auto_fix_normal', label: '방지 및 감소대책', component: () => import(`${'./patrolImprove.vue'}`) },
      ];
      if (this.popupParam.saiPatrolId) {
        this.tabItems = this.tabItems.concat(this.addTabItems);
      }
      this.$set(this.attachInfo, 'taskKey', this.popupParam.saiPatrolId)
    },
    closePopup(data) {
      this.$emit('closePopup', data);  
    },
    transInfo(data) {
      this.popupParam.saiPatrolId = data.saiPatrolId;
    },
    changeStatus(data) {
      this.tabItems = this.tabItems.concat(this.addTabItems);
      this.$set(this.attachInfo, 'taskKey', data)
      this.$set(this.attachInfo, 'isSubmit', uid())
    },
    tabClick() {
      this.count++;
    }
  }
};
</script>
